import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const General_Pagination = ({
  arr,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  pagename,
}) => {
  const totalPages = Math.ceil(arr.length / itemsPerPage);
  const pageLinks = [];
  const maxVisiblePages = 5;
  if (totalPages <= maxVisiblePages) {
    for (let i = 1; i <= totalPages; i++) {
      pageLinks.push(
        <PaginationItem key={i} className={currentPage === i ? "active" : ""}>
          <PaginationLink
            href="#pablo"
            onClick={() => {
              localStorage.setItem(`${pagename}Page`, i);
              setCurrentPage(i);
            }}
          >
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }
  } else {
    const startPage = Math.max(
      1,
      currentPage - Math.floor(maxVisiblePages / 2)
    );
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (startPage > 1) {
      pageLinks.push(
        <PaginationItem key={1}>
          <PaginationLink
            href="#pablo"
            onClick={() => {
              setCurrentPage(1);
              localStorage.setItem(`${pagename}Page`, 1);
            }}
          >
            1
          </PaginationLink>
        </PaginationItem>
      );
      if (startPage > 2) {
        pageLinks.push(
          <PaginationItem key="startEllipsis" disabled>
            <PaginationLink href="#">...</PaginationLink>
          </PaginationItem>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageLinks.push(
        <PaginationItem key={i} className={currentPage === i ? "active" : ""}>
          <PaginationLink
            href="#pablo"
            onClick={() => {
              setCurrentPage(i);
              localStorage.setItem(`${pagename}Page`, i);
            }}
          >
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageLinks.push(
          <PaginationItem key="endEllipsis" disabled>
            <PaginationLink href="#">...</PaginationLink>
          </PaginationItem>
        );
      }
      pageLinks.push(
        <PaginationItem key={totalPages}>
          <PaginationLink
            href="#pablo"
            onClick={() => {
              setCurrentPage(totalPages);
              localStorage.setItem(`${pagename}Page`, totalPages);
            }}
          >
            {totalPages}
          </PaginationLink>
        </PaginationItem>
      );
    }
  }

  return (
    <>
      <nav className="mb-2">
        <Pagination
          className="pagination justify-content-end mb-3"
          listClassName="justify-content-end mb-0"
        >
          <PaginationItem disabled={currentPage === 1}>
            <PaginationLink
              href="#"
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              <i className="fas fa-angle-left" />
              <span className="sr-only">Previous</span>
            </PaginationLink>
          </PaginationItem>
          {pageLinks}
          <PaginationItem disabled={currentPage === totalPages}>
            <PaginationLink
              href="#"
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              <i className="fas fa-angle-right" />
              <span className="sr-only">Next</span>
            </PaginationLink>
          </PaginationItem>
        </Pagination>
      </nav>
    </>
  );
};

export default General_Pagination;
